// extracted by mini-css-extract-plugin
module.exports = {"outer":"_28yhh","dFlex":"_14JqB","imageWrapper":"_1sv5f","warranty":"_1bcfo","activeStyle":"_38MW_","text-one":"_3H0Ye"};